import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import { FCM_SUPPORTER_SHARE_VISUALS } from '@change-corgi/fcm/configs';

const SUPPORTER_SHARE_VISUALS_EXPERIMENT_NAME = 'supporter_share_visuals_experiment';

export async function isShareVisualsExperimentEnabled(utilityContext: UtilityContext) {
	const fcm = await utilityContext.fcm.get({
		shareVisualsEnabled: FCM_SUPPORTER_SHARE_VISUALS,
	});
	const experiment = utilityContext.experiments.get(SUPPORTER_SHARE_VISUALS_EXPERIMENT_NAME);
	// Verify the FCM is enabled
	if (!fcm.shareVisualsEnabled) return false;
	// Treating the experiment ONLY if the FCM is enabled
	void experiment.treat();
	return experiment.variation === 'v1';
}
